import { BlockList } from '@zillow/cms-blocks';
import React from 'react';

import { PostsTemplate } from '../../../components/PostsTemplate';
import TermHero from '../../../components/TermHero/TermHero';
import { buildPrimaryTermPage } from '../../../util/buildPrimaryTermPage';
import { Layout } from '../[[...slug]]';

const CategoryPageContent = ({ term, initialPage, stickySidebarTop }) => (
    <PostsTemplate
        posts={term.posts}
        initialPage={initialPage}
        stickySidebarTop={stickySidebarTop}
        hero={
            <TermHero
                total={term.posts?.total}
                description={term.description}
                name={term.name}
            />
        }
        sidebar={
            term.sidebar ? (
                <BlockList blocks={term.sidebar?.blocks || []} />
            ) : null
        }
        footer={term.footer}
        archiveCategory={term.id}
        baseLink={term.link}
    />
);

const { getStaticProps, getStaticPaths, WrappedPage } =
    await buildPrimaryTermPage({
        basePath: '/agents/blog/category',
        site: 'AGENTS',
        taxonomy: 'CATEGORY',
        LayoutComponent: Layout,
        ContentComponent: CategoryPageContent,
        additionalLayoutProps: {
            isBlog: true,
        },
        menuPropName: 'submenu',
        hasStickyNav: true,
    });

export { getStaticProps, getStaticPaths };
export default WrappedPage;
